import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { Creators as actions } from './redux/actions';
import PriceComponent from './components/Price'
import CalculatorComponent from './components/Calculator/Calculator'

import { setTranslations, setLocale } from 'react-i18nify';

import configureStore from './redux/store'
import * as serviceWorker from './serviceWorker';

const store = configureStore();

try {
    const element = document.getElementById('react-PriceComponent');
    const bestDeal = element.getAttribute('data-best-deal');
    const purchaseMethodOrder = element.getAttribute('data-purchase-method-order');
    const extraDisclaimer = element.getAttribute('data-extra-disclaimer');

    ReactDOM.render(
        <Provider store={store}>
            <PriceComponent purchaseMethodOrder={purchaseMethodOrder} bestDeal={bestDeal} extraDisclaimer={extraDisclaimer} />
        </Provider>,
        element
    );
} catch (error) {
    console.log(error);
}

try {
    const element = document.getElementById('react-CalculatorComponent');
    const purchaseMethodOrder = element.getAttribute('data-purchase-method-order');

    ReactDOM.render(
        <Provider store={store}>
            <CalculatorComponent purchaseMethodOrder={purchaseMethodOrder} />
        </Provider>,
        element
    );
} catch (error) {
    console.log(error);
}

window.WebAutoCalculator = {
    init: (config = {}) => {
        const {
            token,
            lang = 'en',
            quoteId,
            organizationId,
            organizationUnitId,
            showroomApiUrl,
            location,
            i18n = {
                en: {
                    date: {
                        long: 'MMMM do, yyyy'
                    },
                    paymentFrequency: {
                        "12": "Monthly",
                        "24": "Semi-monthly",
                        "26": "Bi-weekly",
                        "52": "Weekly"
                    },
                    purchaseMethod: {
                        "cash": "Cash",
                        "finance": "Finance",
                        "lease": "Lease"
                    },
                    paymentTitle: "I Want to Pay",
                    initialCashDownTitle: "Initial Cash Down",
                    estimatedTradeInTitle: "Your Estimated Trade-In",
                    tradeInLabel: "Trade-In",
                    lienLabel: "Balance Due on Trade-In"
                }
            }
        } = config;

        const queryParams = {
            location,
            quoteId,
            organizationId,
            organizationUnitId
        }

        const serverRuntimeConfig = {
            showroomApiUrl
        }

        setTranslations(i18n);
        setLocale(lang);

        store.dispatch(actions.initializeStore(token, lang, queryParams, serverRuntimeConfig))
    },

    getInfo: () => {
        return store.getState();
    },

    refresh: () => {
        store.dispatch(actions.refreshQuote())
    }
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
